import clsx from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

export interface CircularProgressProps extends ComponentPropsWithoutRef<'div'> {
    /**
     * Value of the progress between 0 and 100.
     */
    value: number;
}

export const CircularProgress = forwardRef<HTMLDivElement, CircularProgressProps>(
    ({ value, className, ...props }, ref) => {
        return (
            // biome-ignore lint/a11y/useFocusableInteractive: why should it be focusable?
            <div
                ref={ref}
                role="progressbar"
                aria-valuenow={value}
                aria-valuemin={0}
                aria-valuemax={100}
                className={clsx(className, 'relative overflow-hidden rounded-full')}
                {...props}
            >
                {/* biome-ignore lint/a11y/noSvgWithoutTitle: no title needed here */}
                <svg viewBox="0 0 320 320" className="-rotate-90 absolute inset-px rounded-full">
                    <circle
                        fill="none"
                        strokeWidth={140}
                        r={160}
                        cx={160}
                        cy={160}
                        className="stroke-[--sp-color-border-base]"
                    />
                    <circle
                        fill="none"
                        strokeWidth={140}
                        r={160}
                        cx={160}
                        cy={160}
                        className="stroke-[--sp-color-action-bg-success-default]"
                        style={{
                            strokeDasharray: 2 * Math.PI * 160,
                            strokeDashoffset: ((100 - value) / 100) * (2 * Math.PI * 160),
                            transition: '0.2s linear stroke-dashoffset',
                        }}
                    />
                </svg>
            </div>
        );
    }
);
